export function getDefaultExpandedJobId(eventsForDay: { id: string }[], expandedJobId: string | null | false) {
  if (expandedJobId === false) return null
  if (expandedJobId) return expandedJobId
  return eventsForDay.length === 1 ? eventsForDay[0].id : null
}
